import React, { useContext } from "react"
import { ExperienceEditorContext } from "./ExperienceEditorContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"
import OptimizerButton from "./optimizer/optimizer-button"
import { WingsTextArea } from "@wingspans-ui"

const ExperienceBulletInput = ({ highlight, index, placeholder }) => {
  const { experience = {}, dispatchHighlightAction } = useContext(ExperienceEditorContext)

  
  const updateData = (event) => {
    const value = event.target.value
    dispatchHighlightAction("UPDATE_INPUT_VALUE", value, index)
  }

  const removeInput = (event) => {
    event.preventDefault()
    dispatchHighlightAction("DELETE_INPUT_FIELD", null, index)
  }

  return (
    <>
      <div className="form-element experience-bullet-row w-flex w-flex-row w-items-center w-gap-1 w-mb-1">
        <WingsTextArea
          className="experience-bullet-textarea w-full"
          value={highlight ?? ""}
          placeholder={placeholder ?? ""}
          onChange={updateData}
          rows={1}
          autoResize
          fullWidth
        />
        <OptimizerButton type='bullet' text={highlight ?? ""} updateData={updateData} tense={experience.endDateMonth == null && experience.endDateYear == null ? "present" : "past"}
        />
        <button
          className="experience-bullet-remove-button w-shrink-0"
          onClick={removeInput}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" color="#363636" />
        </button>
      </div>
    </>
  )
}

export default ExperienceBulletInput
